'use client';

import { styled } from '@linaria/react';
import navigation from '@fe-news/configs/navigation';
import { NewsCategory } from '@fe-news/constants/categories';
import Link from 'next/link';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

const Container = styled.nav`
  display: flex;
`;

const Tab = styled.button<{ currentCategory: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;

  a {
    font-size: 16px;
    letter-spacing: 0.67px;
    color: ${({ currentCategory }) => (currentCategory ? '#e03f19' : '#848d97')};
    font-weight: ${({ currentCategory }) => (currentCategory ? '500' : '400')};
  }

  &:not(:last-child)::after {
    content: '';
    width: 2px;
    height: 16px;
    background-color: #e2e8f1;
    margin: 3px 8px;
    display: inline-block;
    vertical-align: middle;
  }
`;

type MemberMainNavBarProps = {
  mainTabCategory: NewsCategory;
};

const MemberMainNavBar = ({ mainTabCategory }: MemberMainNavBarProps) => {
  return (
    <Container>
      {navigation[NewsCategory.MY_NEWS].navs.map(value => {
        const GTM_EVENT = {
          [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAB,
          [GTMEventKey.SECTION]: 'News_Category_我的新聞',
          [GTMEventKey.CLICK_ITEM]: value.name
        };

        const onClick = () => {
          sendGTM(GTM_EVENT);
        };

        return (
          <Tab
            key={value.category}
            currentCategory={value.category === mainTabCategory}
            aria-current={value.category === mainTabCategory ? 'page' : undefined}
          >
            <Link href={value.link} onClick={onClick} prefetch={false}>
              {value.name}
            </Link>
          </Tab>
        );
      })}
    </Container>
  );
};

export default MemberMainNavBar;
